import React, { Component } from "react";

// import Navigation from "../components/Navigation";
// import { baseUrl } from "../config";
import { Navigation } from "./Navigation";
import { LeadsForm } from "./LeadsForm";

import "./scss/_givenLeads.scss";

class GivenLeads extends Component {
  constructor() {
    super();
    this.state = {
      isSuccess: false,
      stateResponse: [],
      cityResponse: [],
      token: "",
      givenLeadsResponse: {},
    };
  }

  componentDidMount() {
    // this.stateApiCall();
    // this.cityApiCall();
    // this.affliateApiCall();
    // const token = localStorage.getItem("accessToken");
    // if (token) {
    //   this.setState({
    //     token,
    //   });
    // }
  }

  displaySuccess = () => {
    this.setState({ isSuccess: true });
  };

  // stateApiCall = async () => {
  //   const stateData = await axios.getApiCall(`su/affiliate/state`);
  //   this.setState({ stateResponse: stateData.data.data.states });
  // };

  // cityApiCall = async () => {
  //   const cityData = await axios.getApiCall(`su/affiliate/state?city=1`);
  //   this.setState({ cityResponse: cityData.data.data.city });
  // };

  // affliateApiCall = async () => {
  //   const { data } = await axios.get(
  //     `${baseUrl}/su/affiliate/dashboard/insight`,
  //     {
  //       headers: { "x-access-token": localStorage.getItem("accessToken") },
  //     }
  //   );
  //   this.setState({ givenLeadsResponse: data.data });
  // };

  render() {
    return (
      <div className="GivenLeads">
        <Navigation />

        <div className="LeadsModal">
          {/* < className="LeadsModal__modal"> */}
          <div className="LeadsModal__modalContainer">
            <LeadsForm />
          </div>
        </div>
      </div>
    );
  }
}

export default GivenLeads;
